import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      q: '51动漫官网是什么？',
      a: '51动漫官网是集51动漫网和51动漫网站优质资源于一体的国产动漫聚合导航平台，提供动漫爱好者官方直达入口。用户可以通过51动漫主页快速找到最新、最热门的国产动漫资源进行观看，无需在多个网站之间来回跳转。',
    },
    {
      q: '如何通过51动漫观看国产动漫？',
      a: '访问51动漫官网首页后，可以通过热搜榜单、焦点专题、动漫推荐等模块找到感兴趣的动漫作品。点击对应的动漫卡片或链接即可进入51动漫网站观看页面。平台支持桌面端与移动端，手机浏览器访问同样流畅。',
    },
    {
      q: '51动漫的资源更新频率如何？',
      a: '51动漫网持续追踪国产动漫更新动态，每日实时同步各动漫番剧的最新话。热门动漫通常在24小时内完成更新，确保51动漫用户无需久等。遇到番剧停更或延期，平台也会第一时间发布相关公告。',
    },
    {
      q: '51动漫是否需要注册或付费？',
      a: '51动漫官网作为动漫资源聚合导航平台，所有动漫入口功能均免费向用户开放，无需注册账号即可使用。用户可以直接通过51动漫主页访问感兴趣的内容，享受便捷的动漫观看服务。',
    },
    {
      q: '51动漫支持哪些设备观看？',
      a: '51动漫网站全面适配桌面端（Windows/Mac）、移动端（iOS/Android）以及平板设备。页面采用响应式设计，自适应不同屏幕尺寸。推荐使用Chrome、Safari或Edge等主流浏览器访问51动漫官网以获得最佳体验。',
    },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于51动漫官网的常见疑问，这里为你一一解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-background-50/50 transition-colors"
              >
                <h3 className="font-heading text-base md:text-lg text-foreground-950 pr-4">
                  {faq.q}
                </h3>
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 ${openIndex === idx ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'}`}>
                  <i className="ri-add-line text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}